import { useState } from "react";
import { useNavigate } from "react-router";

import { Button, ButtonStyle, DateTimePicker, DetailCardSection, FormField } from "@prequel/shared-components";

import { useDatasetContext } from "@/pages/import/DatasetsPage/DatasetPage";
import { formatAsUTC } from "@/types";

const DatasetRecordDebug = () => {
  const navigate = useNavigate();
  const { dataset } = useDatasetContext();
  const [recordID, setRecordID] = useState("");
  const [asOf, setAsOf] = useState("");

  const trimmed = recordID.trim();

  const onDebug = () => {
    if (!trimmed) {
      return;
    }
    const asOfUTC = asOf ? formatAsUTC(asOf) : undefined;
    const query = asOfUTC ? `?as_of=${encodeURIComponent(asOfUTC)}` : "";
    navigate(`/import/datasets/${dataset.id}/records/${encodeURIComponent(trimmed)}${query}`);
  };

  return (
    <div className="mt-6">
      <DetailCardSection title="Record debug">
        <p className="mb-3 text-sm text-stone-600">
          Look up a single record to see how far it got through extract, transform, validation, load and
          acknowledgement.
        </p>
        <div className="space-y-3">
          <FormField
            id="record_id"
            type="text"
            label="Record ID"
            value={recordID}
            onChangeHandler={setRecordID}
            placeholder="rec_001"
          />
          <DateTimePicker label="As of" dateTime={asOf} setDateTime={setAsOf} />
          <p className="text-xs font-medium text-stone-400">Leave empty to see the record&apos;s current state.</p>
          <Button text="Debug record" type={ButtonStyle.SECONDARY} disabled={!trimmed} onClick={onDebug} />
        </div>
      </DetailCardSection>
    </div>
  );
};

export default DatasetRecordDebug;
